import { createStore } from 'vuex'
import axios from 'axios';

export default createStore({
    state: {
        popularProducts: [
            // {
            //     id: 1,
            //     name: 'Букет “Лилово-розовый”',
            //     price: 4000,
            //     url: 'mok-photo.png'
            // },
            // {
            //     id: 2,
            //     name: 'Букет “Лилово-розовый” Букет “Лилово-розовый” Букет “Лилово-розовый”',
            //     price: 4000,
            //     url: 'mok-photo.png'
            // },
            // {
            //     id: 3,
            //     name: 'Букет “Лилово-розовый”',
            //     price: 4000,
            //     url: 'mok-photo.png'
            // },
            // {
            //     id: 4,
            //     name: 'Букет “Лилово-розовый”',
            //     price: 4000,
            //     url: 'mok-photo.png'
            // },
        ],
        mainCategories: [
            {
                id: 1,
                name: 'букеты'
            },
            {
                id: 2,
                name: 'букеты'
            },
            {
                id: 3,
                name: 'букеты'
            },
            {
                id: 4,
                name: 'букеты'
            },
            {
                id: 5,
                name: 'букеты'
            },
            {
                id: 6,
                name: 'букеты'
            },
            {
                id: 7,
                name: 'букеты'
            },
            {
                id: 8,
                name: 'букеты'
            },
            {
                id: 9,
                name: 'букеты'
            },
            {
                id: 10,
                name: 'букеты'
            },
        ],
        categories: [
            {
                id: 1,
                name: 'Розы'
            },
            {
                id: 2,
                name: 'Хризантемы'
            },
            {
                id: 3,
                name: 'Пионы'
            },
            {
                id: 4,
                name: 'Альстромерии'
            },
        ],
        products: [
            // {
            //     id: 1,
            //     name: 'Букет “Лилово-розовый”',
            //     price: 4000,
            //     url: 'mok-photo.png',
            //     quantity: 1
            // },
            // {
            //     id: 2,
            //     name: 'Букет “Лилово-розовый” Букет “Лилово-розовый” Букет “Лилово-розовый”',
            //     price: 4000,
            //     url: 'mok-photo.png',
            //     quantity: 1
            // },
            // {
            //     id: 3,
            //     name: 'Букет “Лилово-розовый”',
            //     price: 4000,
            //     url: 'mok-photo.png'
            // },
            // {
            //     id: 4,
            //     name: 'Букет “Лилово-розовый”',
            //     price: 4000,
            //     url: 'mok-photo.png'
            // },
            // {
            //     id: 5,
            //     name: 'Букет “Лилово-розовый” Букет “Лилово-розовый” Букет “Лилово-розовый”',
            //     price: 4000,
            //     url: 'mok-photo.png'
            // },
            // {
            //     id: 6,
            //     name: 'Букет “Лилово-розовый”',
            //     price: 4000,
            //     url: 'mok-photo.png'
            // },
            // {
            //     id: 7,
            //     name: 'Букет “Лилово-розовый”',
            //     price: 4000,
            //     url: 'mok-photo.png'
            // },
            // {
            //     id: 8,
            //     name: 'Букет “Лилово-розовый” Букет “Лилово-розовый” Букет “Лилово-розовый”',
            //     price: 4000,
            //     url: 'mok-photo.png'
            // },
            // {
            //     id: 9,
            //     name: 'Букет “Лилово-розовый”',
            //     price: 4000,
            //     url: 'mok-photo.png'
            // },
        ],
        selectedCategory: 'Все цветы',
        minPrice: 0,
        maxPrice: 30000,
        sortDirection: '',
        searchValue: '',
        totalPages: 0,
        page: 1,
        cardsPerPage: 9,
        cart: [
            // {
            //     id: 1,
            //     name: 'Букет “Лилово-розовый”',
            //     price: 4000,
            //     url: 'mok-photo.png',
            //     quantity: 1
            // },
            // {
            //     id: 2,
            //     name: 'Название товара длиннымкаким-то необычным названием из цветов',
            //     structure: 'Описание товара 14 шрифта, чтобы заполнить пустое место в описании букета',
            //     price: 4000,
            //     url: 'mok-photo.png',
            //     quantity: 1
            // }
        ],
        categoryValue: '',
        orders: [],
        currentProduct: '',
        mainProductPhoto: '',
        discount: 0
    },
    getters: {
        DISCOUNT(state){
            return state.discount
        },
        SELECTED_PRODUCT(state){
            return state.currentProduct
        },
        POPULAR_FLOWERS(state){
            return state.popularProducts
        },
        POPULAR_PRODUCTS(state){
            return state.popularProducts
        },
        MAIN_CATEGORIES(state){
            return state.mainCategories
        },
        CATEGORIES(state){
            return state.categories
        },
        SELECTED_CATEGORY(state){
            return state.selectedCategory
        },
        PRODUCTS(state){
            return state.products
        },
        CART(state){
            return state.cart
        },
        TOTAL_PAGES(state){
            return state.totalPages
        },
        CARDS_PER_PAGE(state){
            return state.cardsPerPage
        },
        TOTAL_PAGES(state){
            return state.totalPages
        },
        SELECTED_PAGE(state){
            return state.page
        },
        ORDERS(state){
            return state.orders
        },
        CURRENT_PAGE(state){
            return state.page
        },
    },
    mutations: {
        SET_PRODUCTS_TO_STATE: (state, products)=>{
            state.products = products
        },
        SET_TOTAL_PAGES: (state, value)=>{
            state.totalPages = Math.ceil(value / state.cardsPerPage)
        },
        SET_CART: (state, product)=>{
            if(state.cart.length){
                let isProductExist = false;
                state.cart.map(function(item){
                    if(item.id === product.id){
                        isProductExist = true;
                        item.quantity++
                    }
                })
                if(!isProductExist){
                    state.cart.push(product)
                }
            }else{
                state.cart.push(product)
            }
        },
        REMOVE_FROM_CART: (state, index)=>{
            state.cart.splice(index, 1)
        },
        INCREASE: (state, index)=>{
            state.cart[index].quantity++
            
        },
        DECREASE: (state, index)=>{
            if (state.cart[index].quantity > 1){
                state.cart[index].quantity--
            }
        },
        SET_SEARCH_VALUE: (state, value) => {
            state.searchValue = value
        },
        REMOVE_SEARCH_VALUE: (state)=>{
            state.searchValue = ''
        },
        SET_SELECTED_CATEGORY: (state, category)=>{
            state.selectedCategory = category
        },
        SET_MIN_VALUE: (state, minVal)=>{
            state.minPrice = minVal
        },
        SET_MAX_VALUE: (state, maxVal)=>{
            state.maxPrice = maxVal
        },
        SET_PAGE: (state, value)=>{
            state.page = value
        },
        SET_DEFAULT_PAGE_NUMBER: (state)=>{
            state.page = 1
        },
        SET_CATEGORY_VALUE: (state, value)=>{
            state.categoryValue = value
        },
        SET_ORDERS_TO_STATE: (state, orders)=>{
            state.orders = orders
        },
        SET_POPULAR_PRODUCTS: (state, products)=>{
            state.popularProducts = products
        },
        SET_CATEGORIES: (state, categories)=>{
            state.categories = categories
        },
        SET_ONE_PRODUCT: (state, data)=>{
            state.currentProduct = data
            state.mainProductPhoto = data.url
        },
        SET_DISCOUNT: (state, discount) =>{
            state.discount = discount
        },
    },
    actions: {
        IS_DISCOUNT({commit}, discount){
            commit('SET_DISCOUNT', discount)
        },
        RESET_SEARCH_VALUE({commit}){
            commit('REMOVE_SEARCH_VALUE')
        },
        GET_MIN_VALUE({commit}, minVal){
            commit('SET_MIN_VALUE', minVal)
        },
        GET_MAX_VALUE({commit}, maxVal){
            commit('SET_MAX_VALUE', maxVal)
        },
        GET_SEARCH_VALUE({commit}, value){
            commit('SET_SEARCH_VALUE', value)
        },
        GET_ORDERS({commit}){
            let cookie = document.cookie.match(/token=(.+?)(;|$)/);
            axios.get('https://lenbuket.ru:8443/api/orders/orders-by-admin',
            {headers: {Authorization: `Bearer ${cookie[1]}`}
            }).then((res)=>{
                commit('SET_ORDERS_TO_STATE', res.data.rows)
                // this.orders = res.data.rows
            })
        },
        GET_SORTED_ORDERS({commit}, status){
            let cookie = document.cookie.match(/token=(.+?)(;|$)/);
            axios.get('https://lenbuket.ru:8443/api/orders/workstatus', 
            {headers: {Authorization: `Bearer ${cookie[1]}`},
            params:{
                workstatus: status
            }}).then((res)=>{
                commit('SET_ORDERS_TO_STATE', res.data.rows)
            })
        },
        GET_ONE_PRODUCT({commit}, data){
            commit('SET_ONE_PRODUCT', data)
        },
        GET_PRODUCTS({commit}){
            if(this.state.searchValue != ''){
                return axios({
                    url: 'https://lenbuket.ru:8443/api/goods/search',
                    method: "GET",
                    params:{
                        searchVal: this.state.searchValue,
                        page: this.state.page
                    }
                }).then((products)=>{
                    commit('SET_PRODUCTS_TO_STATE', products.data);
                    commit('SET_TOTAL_PAGES', products.data.count);
                })
            }

            if(this.state.selectedCategory !=='Все цветы'){
                return axios({
                    url: 'https://lenbuket.ru:8443/api/goods/sort',
                    method: "GET",
                    params:{
                        category: this.state.selectedCategory,
                        subcategory: this.state.categoryValue,
                        dir: this.state.sortDirection,
                        page: this.state.page,
                        maxVal: this.state.maxPrice,
                        minVal: this.state.minPrice,
                    }

                }).then((products)=>{
                    commit('SET_PRODUCTS_TO_STATE', products.data);
                    commit('SET_TOTAL_PAGES', products.data.count);
                    
                })
            }
            return axios(`https://lenbuket.ru:8443/api/goods/flowers/all`,{
                method: "GET",
                params:{
                    page: this.state.page,
                    dir: this.state.sortDirection,
                    maxVal: this.state.maxPrice,
                    minVal: this.state.minPrice,
                }
                }).then((products)=>{
                    commit('SET_PRODUCTS_TO_STATE', products.data);
                    commit('SET_TOTAL_PAGES', products.data.count);
                }).catch()
        },
        GET_POPULAR_PRODUCTS({commit}){
            return axios({
                url: 'https://lenbuket.ru:8443/api/goods/flowers/popular',
                method: "GET"
            }).then((products)=>{
                commit('SET_POPULAR_PRODUCTS', products.data);
            })
        },
        GET_CATEGORIES({commit}){
            return axios('https://lenbuket.ru:8443/api/category/all',
            {
                method: "GET",
            }).then((categories)=>{
                commit('SET_CATEGORIES', categories.data);
            })
        },
        ADD_TO_CART({commit}, product){
            commit('SET_CART', product);
        },
        INCREASE_QTY({commit}, index){
            commit('INCREASE', index)
        },
        DECREASE_QTY({commit}, index){
            commit('DECREASE', index)
        },
        DELETE_FROM_CART({commit}, index){
            commit('REMOVE_FROM_CART', index)
        },
        GET_PAGE_NUMBER({commit}, value){
            commit('SET_PAGE', value)
        },
        RESET_PAGE_NUMBER({commit}){
            commit('SET_DEFAULT_PAGE_NUMBER')
        },
        GET_CATEGORY_VALUE({commit}, value){
            commit('SET_CATEGORY_VALUE', value)
        },
        RESET_CATEGORY({commit}){
            commit('SET_DEFAULT_CATEGORY')
        },
        SELECT_CATEGORY({commit}, value){
            commit('SET_SELECTED_CATEGORY', value)
        },
    }
})
